<template>
  <v-content>
    <v-logged-in-base-tool-bar
      v-if="isLoggedIn"
      @sign-out-button-click="signOut"
      />
      <router-view
        v-if="isLoggedIn"
        />
  </v-content>
</template>

<script>
import { app } from "@/core/firebase.js"
import { ParentRepository } from "@/repository/ParentRepository.js"
import { firestore } from "@/repository/client/firestore.js"
import { auth } from "@/auth/client/firebase"
import { UserAuth } from "@/auth/user"
import VLoggedInBaseToolBar from "@/components/organisms/parent/VLoggedInBaseToolBar.vue"

export default {
  components: {
    VLoggedInBaseToolBar
  },
  data() {
    return {
      isLoggedIn: false,
      repo: null,
      parent: null,
      auth: null,
      links: ["Home", "About Us", "Team", "Services", "Blog", "Contact Us"]
    }
  },
  methods: {
    async signOut() {
      const result = await this.auth.signOut()
      this.$store.commit("logoutAsParent")
      this.$router.push({ name: "parentTop" })
    }
  },
  created: function() {
    this.auth = new UserAuth(auth)
    app.auth().onAuthStateChanged(async user => {
      if (user) {
        this.repo = new ParentRepository(firestore)
        this.parent = await this.repo.get(user.uid)
        this.$store.commit("loginAsParent", this.parent)
        this.isLoggedIn = true
      } else {
        this.isLoggedIn = false
      }
    })
  }
}
</script>

<style scoped>
.white-text {
  color: white;
}
</style>